import { Check } from 'lucide-react';

const features = [
  'Noite na Varjota',
  'Encontro entre amigos',
  'Música boa',
  'Comida e petiscos',
  'Mesas na cobertura',
  'Área Climatizada',
];

export default function EnvironmentSection() {
  return (
    <section id="ambiente" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Text */}
            <div className="reveal reveal-left order-2 lg:order-1">
              <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
                O AMBIENTE
              </span>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 leading-tight mb-6">
                Encontros, música e o verdadeiro clima de <span className="text-gold-500">buteco</span>
              </h2>
              <p className="text-brown-600 text-base md:text-lg leading-relaxed mb-8">
                Entre petiscos, pratos nordestinos, coquetéis e música, o Buteco do Baiano entrega uma experiência descontraída para quem quer sair da rotina e aproveitar um bom barzinho na região da Varjota.
              </p>

              {/* Feature list */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {features.map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gold-500/10 text-gold-500 flex-shrink-0">
                      <Check size={14} />
                    </span>
                    <span className="text-brown-700 text-sm font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Image */}
            <div className="reveal reveal-right order-1 lg:order-2">
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://storage.readdy-site.link/project_files/2d00fbf4-9726-483a-b70b-ea6e421eb3f8/2d82c532-86b3-4f32-987a-bf6915a3f4ff_compressed_Imagem-1-gerada.webp"
                  alt="Ambiente do Buteco do Baiano"
                  className="w-full h-auto object-cover aspect-[4/3]"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
